<template>
  <div class="modal fade" id="shopUserModal" tabindex="-1" aria-hidden="true" ref="modalEl">
    <div class="modal-dialog modal-dialog-centered modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title fw-bolder">
            {{ isEdit ? $t('landlord.shops.user_edit_title') : $t('landlord.shops.user_add_title') }}
          </h5>
          <button type="button" class="btn-close" @click="close"></button>
        </div>

        <div class="modal-body py-6 px-8">
          <div class="row g-5">
            <div class="col-md-6">
              <label class="form-label fw-bold required">{{ $t('landlord.shops.fields.admin_lastname') }}</label>
              <input v-model="form.lastname" type="text" class="form-control form-control-solid"
                     :class="{ 'is-invalid': errors.lastname }" />
              <div v-if="errors.lastname" class="invalid-feedback">{{ errors.lastname[0] }}</div>
            </div>
            <div class="col-md-6">
              <label class="form-label fw-bold required">{{ $t('landlord.shops.fields.admin_firstname') }}</label>
              <input v-model="form.firstname" type="text" class="form-control form-control-solid"
                     :class="{ 'is-invalid': errors.firstname }" />
              <div v-if="errors.firstname" class="invalid-feedback">{{ errors.firstname[0] }}</div>
            </div>
            <div class="col-md-6">
              <label class="form-label fw-bold required">{{ $t('landlord.shops.fields.admin_email') }}</label>
              <input v-model="form.email" type="email" class="form-control form-control-solid"
                     :class="{ 'is-invalid': errors.email }" />
              <div v-if="errors.email" class="invalid-feedback">{{ errors.email[0] }}</div>
            </div>
            <div class="col-md-6">
              <label class="form-label fw-bold">{{ $t('landlord.shops.fields.admin_phone') }}</label>
              <InputTel
                  name="shop_user_phone"
                  containerClass=""
                  v-model:phone="form.phone"
                  v-model:phone-code="form.phone_code"
              />
            </div>
            <div class="col-md-6">
              <label class="form-label fw-bold" :class="{ required: !isEdit }">
                {{ $t('landlord.shops.fields.admin_password') }}
                <span v-if="isEdit" class="text-muted fw-normal fs-8"> ({{ $t('landlord.shops.password_optional') }})</span>
              </label>
              <input v-model="form.password" type="password" class="form-control form-control-solid"
                     :class="{ 'is-invalid': errors.password }"
                     :placeholder="isEdit ? '••••••••' : ''" />
              <div v-if="errors.password" class="invalid-feedback">{{ errors.password[0] }}</div>
            </div>
            <div class="col-md-6">
              <label class="form-label fw-bold">{{ $t('landlord.shops.user_role') }}</label>
              <select v-model="form.role" class="form-select form-select-solid">
                <option value="Owner">Owner</option>
              </select>
            </div>
          </div>
        </div>

        <div class="modal-footer">
          <button type="button" class="btn btn-light" @click="close">
            {{ $t('landlord.shops.cancel') }}
          </button>
          <button type="button" class="btn btn-primary" @click="onSubmit" :disabled="saving">
            <span v-if="saving" class="spinner-border spinner-border-sm me-2"></span>
            {{ isEdit ? $t('landlord.shops.save') : $t('landlord.shops.user_create') }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import InputTel from '@/components/InputTel.vue'

export default {
    name: 'ShopUserModal',
    components: { InputTel },
    props: {
        user: { type: Object, default: null },
    },
    emits: ['submit'],
    data() {
        return {
            form: this.emptyForm(),
            errors: {},
            saving: false,
            modalInstance: null,
        }
    },
    computed: {
        isEdit() {
            return !!this.user
        },
    },
    watch: {
        user(val) {
            if (val) {
                this.form = {
                    lastname:   val.lastname   || '',
                    firstname:  val.firstname  || '',
                    email:      val.email      || '',
                    phone:      val.phone      || '',
                    phone_code: val.phone_code || '',
                    password:   '',
                    role:       val.role       || 'Owner',
                }
            } else {
                this.form = this.emptyForm()
            }
            this.errors = {}
        },
    },
    mounted() {
        if (typeof bootstrap !== 'undefined') {
            this.modalInstance = new bootstrap.Modal(this.$refs.modalEl, { backdrop: 'static' })
        }
    },
    methods: {
        emptyForm() {
            return { lastname: '', firstname: '', email: '', phone: '', phone_code: '', password: '', role: 'Owner' }
        },

        open() {
            this.errors = {}
            this.modalInstance?.show()
        },

        close() {
            this.modalInstance?.hide()
        },

        onSubmit() {
            this.saving = true
            this.errors = {}
            this.$emit('submit', {
                data: { ...this.form },
                onSuccess: () => {
                    this.saving = false
                    this.close()
                },
                onError: (errors) => {
                    this.saving = false
                    this.errors = errors
                },
            })
        },
    },
}
</script>
